// @flow

import { connect } from 'react-redux';
import Facets from './facets';
import { getFacets } from '../../../store/assortment/selectors';

type StateProps = {|
  facets: {
    [string]: {[string]: number },
  },
|};

const mapStateToProps = (state): StateProps => ({
  facets: getFacets(state),
});

export default connect<any, any, StateProps, any, any, any>(mapStateToProps)(Facets);
